'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Input from '@mui/material/Input';
export default function ConditionalHiddenInput({ name, value = '' }) {
    if (!value)
        return null;
    return _jsx(Input, { type: "hidden", name: name, value: value });
}
